var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9795 6.11161C3.97936 6.40627 3.86867 6.68881 3.67179 6.89707C3.4749 7.10533 3.20795 7.22225 2.92965 7.2221C2.65136 7.22195 2.38451 7.10475 2.18783 6.89629C1.99114 6.68782 1.88072 6.40516 1.88086 6.11049C1.881 5.81583 1.99168 5.53328 2.18857 5.32503C2.38545 5.11677 2.65241 4.99985 2.9307 5C3.209 5.00015 3.47584 5.11735 3.67253 5.32581C3.86922 5.53428 3.97963 5.81694 3.9795 6.11161ZM4.01098 8.04483H1.91234V15H4.01098V8.04483ZM7.32682 8.04483H5.23868V15H7.30583V11.3502C7.30583 9.31698 9.80846 9.1281 9.80846 11.3502V15H11.8809V10.5947C11.8809 7.1671 8.17677 7.29487 7.30583 8.97811L7.32682 8.04483Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d9cd5dcab33568bc6b760405fb28ca88.svg";
export { ForwardRef as ReactComponent };